import { NameSpacing } from '../../../../../../NonReact/utils/NameSpacing'

export enum TabNames {
    DETAILS = 'details',
    SCOPE = 'scope',
    POLICY = 'policy',
    SETTINGS = 'settings'
}

export enum DetailsTabFieldNames {
    ID = 'id',
    DESCRIPTION = 'description'
}

export enum ScopeTabFieldNames {
    CME_ID = 'cmeID',
    TELEPHONY_SERVER_ID = 'telsysID',
    PARTITION_ID = 'partitionID',
    DEVICE_ID = 'deviceID',
    FILTER_RECURSIVELY = 'filterRecursively'
}

export enum PolicyFieldNames {
    POLICIES = 'policies'
}

export enum SettingsFieldNames {
    SETTINGS = 'settings'
}

export const ID_FIELD_NAME: string = NameSpacing(TabNames.DETAILS, DetailsTabFieldNames.ID)
export const DESCRIPTION_FIELD_NAME: string = NameSpacing(TabNames.DETAILS, DetailsTabFieldNames.DESCRIPTION)

export const CME_ID_FIELD_NAME: string = NameSpacing(TabNames.SCOPE, ScopeTabFieldNames.CME_ID)
export const TELEPHONY_SERVER_ID_FIELD_NAME: string = NameSpacing(
    TabNames.SCOPE,
    ScopeTabFieldNames.TELEPHONY_SERVER_ID
)
export const PARTITION_ID_FIELD_NAME: string = NameSpacing(TabNames.SCOPE, ScopeTabFieldNames.PARTITION_ID)
export const DEVICE_ID_FIELD_NAME: string = NameSpacing(TabNames.SCOPE, ScopeTabFieldNames.DEVICE_ID)
export const FILTER_RECURSIVELY_FIELD_NAME: string = NameSpacing(TabNames.SCOPE, ScopeTabFieldNames.FILTER_RECURSIVELY)
